'use client';

import { SearchInteractionProvider } from './SearchInteractionContext';
import { CompanyCard, type CompanyCardData } from './CompanyCard';
import { MobilePagination } from './ResultsTableParts';
import { MOBILE_PAGE_SIZE } from './resultsTableColumns';
import type { TFunction } from 'i18next';
import type { CompanySearchResult } from '@/lib/actions/company-search';

interface MobileResultsListProps {
  mobileResults: CompanySearchResult[];
  t: TFunction<'translation', undefined>;
  onOffsetChange: ((offset: number) => void) | undefined;
  total: number;
  offset: number;
  totalLabel: string;
}

export function MobileResultsList({
  mobileResults,
  t,
  onOffsetChange,
  total,
  offset,
  totalLabel,
}: MobileResultsListProps) {
  return (
<div className="lg:hidden p-3">
              {mobileResults.length === 0 ? (
                <div className="flex items-center justify-center py-12 text-sm text-muted-foreground">
                  {t('search.noResults', { query: '' })}
                </div>
              ) : (
                <SearchInteractionProvider>
                  <div className="flex flex-col gap-3">
                    {mobileResults.map((r) => {
                      const card: CompanyCardData = {
                        euId: r.euId,
                        name: r.name,
                        registerId: r.registerId,
                        registerType: r.registerType,
                        registerCourt: r.registerCourt,
                        city: r.city,
                        postalCode: r.postalCode,
                        totalRevenue: r.totalRevenue,
                        profit: r.profit,
                        employees: r.employees,
                        latestYear: null,
                        faviconUrl: r.faviconUrl,
                        aiSummary: r.aiSummary,
                      };
                      return (
                        <CompanyCard key={r.euId} company={card} view="list" />
                      );
                    })}

                    {onOffsetChange && total > 0 && (
                      <MobilePagination
                        offset={offset}
                        limit={MOBILE_PAGE_SIZE}
                        total={total}
                        totalLabel={totalLabel}
                        onOffsetChange={onOffsetChange}
                      />
                    )}
                  </div>
                </SearchInteractionProvider>
              )}
            </div>
  );
}
